import React from 'react';
import {Icons} from '../../../assets';

export const BackgroundPattern: React.FC = () => (
  <div
    aria-hidden="true"
    className="absolute inset-0 opacity-30 pointer-events-none"
    style={{
      backgroundImage: `url(${Icons.VECTOR_PATTERN})`,
      backgroundRepeat: 'repeat',
      backgroundSize: '400px',
    }}
  />
);
